module.exports = __webpack_public_path__ + "img/tip-5.d321b74d.svg";